import axios from '@utils/axios-web-client'

export async function getWebNotification () {
  const response = axios.get('/api/v1/WebNotificationManagement/GetWebNotification')
  return (await response).data
}
